// extracted by mini-css-extract-plugin
export var shellContainer = "Shell-module__shellContainer___2a57m";
export var testPanelTriggerContainer = "Shell-module__testPanelTriggerContainer___mtQBV";